import React, { useContext, useEffect, useState } from "react";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { getLabel } from "../../../Services/Language/LanguageService";
import Card from "../../../Components/Card/Card";
import { Button } from "primereact/button";
import {
  getActualizacionesApp,
  getActualizacionesUsuarios,
} from "../../../../API/IT/Sesiones/SesionesRequests";
import { TabPanel, TabView } from "primereact/tabview";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { Calendar } from "primereact/calendar";
import { setDateTimeSQL } from "../../../Services/FechasService";

const ActualizacionAppScreen = () => {
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [listDispositivosActualizados, setListDispositivosActualizados] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fecha, setFecha] = useState(new Date());

  const getInfo = async () => {
    setLoading(true);
    if (activeIndex === 0) {
      const d = await getActualizacionesApp(setDateTimeSQL(fecha));
      setListDispositivosActualizados(d);
    } else if (activeIndex === 1) {
      const listT = await getActualizacionesUsuarios(setDateTimeSQL(fecha));
      setData(listT);
    }
    setLoading(false);
  };

  const columns = [
    {
      header: "Dispositivo",
      headerEn: "Device",
      field: "Device",
    },
    {
      header: "Dispositivos Actualizados",
      headerEn: "Updated Devices",
      field: "DispositivosActualizados",
    },
    {
      header: "Version App",
      headerEn: "App Version",
      field: "VersionApp",
    },
  ];

  const table = {
    Columns: columns,
    Data: listDispositivosActualizados,
    loading: loading,
  };

  const columns2 = [
    {
      header: "ID",
      headerEn: "ID",
      field: "idUser",
      hidden: userAuth.IdRol === 1,
      className: "Xsmall",
    },
    {
      header: "Usuario",
      headerEn: "User",
      field: "UserName",
    },
    {
      header: "Dispositivo",
      headerEn: "Device",
      field: "Device",
    },
    {
      header: "Version App",
      headerEn: "App Version",
      field: "VersionApp",
      className: "small",
    },
    {
      header: "Ultimo Ingreso",
      headerEn: "Last Login",
      field: "UltimoIngreso",
      Format: "DateTime",
    },
  ];

  const table2 = {
    Columns: columns2,
    Data: data,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "Actualizaciones", config.language));
    getInfo();
  }, [activeIndex, fecha]);

  return (
    <div
      className="p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "Actualizaciones", config.language)}</h3>
            <Calendar
              monthNavigator
              yearNavigator
              yearRange="2010:2030"
              showButtonBar
              dateFormat="dd/mm/yy"
              value={fecha}
              onChange={(e) => setFecha(e.value)}
              selectionMode="single"
              showIcon
            />
            <Button icon="pi pi-refresh" onClick={getInfo} />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Dispositivos Actualizados">
                <div style={{ height: "82vh" }}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>
              <TabPanel header="Usuarios Actualizados">
                <div style={{ height: "82vh" }}>
                  <AgGrid table={table2} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />
    </div>
  );
};

export default ActualizacionAppScreen;
